/* 
██╗██╗░░░██╗  ██████╗░██╗░██████╗░██╗████████╗░█████╗░██╗░░░░░
██║██║░░░██║  ██╔══██╗██║██╔════╝░██║╚══██╔══╝██╔══██╗██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░██╗░██║░░░██║░░░███████║██║░░░░░
██║██║░░░██║  ██║░░██║██║██║░░╚██╗██║░░░██║░░░██╔══██║██║░░░░░
██║╚██████╔╝  ██████╔╝██║╚██████╔╝██║░░░██║░░░██║░░██║███████╗
╚═╝░╚═════╝░  ╚═════╝░╚═╝░╚═════╝░╚═╝░░░╚═╝░░░╚═╝░░╚═╝╚══════╝
╔════════════════════════════════════════════════════════════╗
║              EQUIPO DE DESARROLLO DE SOFTWARE              ║
║                   MODULO DESARROLLADO POR                  ║
╟┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄┄╢
║ Victor Manuel Calle Londoño                                ║
║ victor.calle@est.iudigital.edu.co                          ║
╚════════════════════════════════════════════════════════════╝
*/
import React, { useState, useEffect, useRef } from "react";
import ListCarnets from "../modules/ListCarnets";
import {
  getCarnetUser,
  getTypeCarnets,
  getUserId,
  updatedCardValidity,
  updatedStatusCarnet,
  downloadCardAccumulated,
  getFileCardById,
} from "../services/userCarnet";
import ViewUserPerCard from "layouts/carnets_per_file/modules/ViewUserPerCard";
import MDBadge from "components/MDBadge";
import FindInPageOutlinedIcon from "@mui/icons-material/FindInPageOutlined";
import DownloadIcon from "@mui/icons-material/Download";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import CreditCardOffOutlinedIcon from "@mui/icons-material/CreditCardOffOutlined";
import { ValidityCarnet } from "../modules/ValidityCarnet";
import FilterController from "components/filter/controller/FilterController";
import { CarnetEditedStatus } from "../modules/CarnetEditedStatus";
import Spinner from "components/MDSpinner";
import MDAlert from "components/Alert";
import usePermission from "hooks/usePermission";
import { downloadFile } from "utils/fileUtils";
import { SUCCESS_MESSAGES, ERROR_MESSAGES } from "constants/messages";
import { handleValidityAlerts } from "utils/handleValidityAlertsUtils";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import MailOutlinedIcon from "@mui/icons-material/MailOutlined";

export default function UserListController() {
  const [limitResult, setLimitResult] = useState([
    {
      id: "1",
      status: "active",
      created: "2023-10-23",
      updated_at: "2023-10-24",
      card_user_id: "22",
      card_type_id: "25",
    },
    {
      id: "2",
      status: "active",
      created: "2023-10-23",
      updated_at: "2023-10-24",
      card_user_id: "22",
      card_type_id: "25",
    },
  ]);

  const [userId, setUserId] = useState({});
  const filterControllerRef = useRef();

  //Lógica para la tabla de listar usuarios carnetizados ---->
  const [listCarnets, setListCarnets] = useState();
  const [error, setError] = useState();
  const [totalPages, setTotalPages] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesStart, setEntriesStart] = useState(0);
  const [entriesEnd, setEntriesEnd] = useState(0);
  const [paginaSize, setPaginaSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [typeAlert, setTypeAlert] = useState("");
  const [message, setMessage] = useState("");
  const [isAlert, setIsAlert] = useState(false);
  const dataTable = "cards"; //Tabla indicada
  const dataFilter = useState([
    {
      field: "DOCUMENTO DE IDENTIFICACIÓN",
      value: "number_id",
    },
    {
      field: "NOMBRES O APELLIDOS",
      value: "name",
    },
    {
      field: "CORREO ELECTRÓNICO",
      value: "email",
    },
    {
      field: "TIPO SANGRE",
      value: "blood_type",
    },
    {
      field: "FECHA CREACIÓN",
      value: "created",
    },
    {
      field: "FECHA VIGENCIA",
      value: "expires_in",
    },
    {
      field: "TIPO CARNET",
      value: "type_carnet",
    },
    {
      field: "ESTADO",
      value: "status",
    },
    {
      field: "INGRESO",
      value: "joined",
    },
    {
      field: "ESTADO DE NOTIFICACIÓN",
      value: "notified",
    },
    {
      field: "ESTADO DE DESCARGA",
      value: "latest_link_status",
    },
    {
      field: "FECHA NOTIFICACIÓN",
      value: "latest_link_created_at",
    },
  ]);

  //Esperar respuesta de la función getCarnetUser y validar respuesta para actualizar la tabla de listado de carnets o mostrar error
  const requestCarnets = async (pageIndex) => {
    try {
      const result = await getCarnetUser(pageIndex);
      if (result.status !== false) {
        const { data, last_page, total, from, to } = result;
        await setListCarnets(data);
        //await setListCarnets2(data);
        await setTotalPages(last_page);
        if (last_page <= pageIndex) {
          await setCurrentPage(last_page);
        }
        await setTotalData(total);
        await setEntriesStart(from);
        await setEntriesEnd(to);
        setError("");
      } else {
        setError("Error al consultar al servidor");
      }
    } catch (error) {
      setError("Error al consultar al servidor");
    }
  };

  const requestDownloadCardById = async (id) => {
    try {
      setLoading(true);
      const result = await getFileCardById(id);
      if (result.status !== false) {
        // Descarga el archivo pkpass utilizando la función de utilidad downloadFile.
        downloadFile(
          result.file,
          "Carnet Digital.pkpass",
          result.contentDisposition,
          (message) => handleAlert("success", message),
          (error) => handleAlert("fail", error),
          SUCCESS_MESSAGES.DOWNLOAD_COMPLETE_CARD,
          ERROR_MESSAGES.DOWNLOAD_FAILED_CARD
        );
      } else {
        handleAlert("fail", result.message || "No se pudo descargar el carnet");
      }
    } catch (error) {
      handleAlert("fail", error.message || "Fallo al descargar el carnet");
    } finally {
      setLoading(false);
    }
  };

  //Descargar carnet por id
  const handleDownloadCardById = (e) => {
    e.preventDefault();
    const {
      dataset: { id },
    } = e.currentTarget;

    if (!id) {
      handleAlert("fail", "No se encontro el identificador del carnet");
      return;
    }
    requestDownloadCardById(id);
  };

  //Cambia el valor de currentPage a la página elegida
  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  //Lógica para el modal de vista ---->
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [viewData, setViewData] = useState({});
  const [typeCarnets, setTypeCarnets] = useState([]);

  // //Esperar respuesta de la función getTypeCarnets y validar respuesta para setear los datos retornados
  const requestTypeCarnets = async () => {
    try {
      const result = await getTypeCarnets();
      setTypeCarnets(result);
    } catch (error) {}
  };

  //abre modal de ver detalles de carnet y setea los valores extra de dicho carnet para visualización
  const handleOpenToModal = async (event) => {
    event.preventDefault();
    setLoading(true);
    const { dataset } = event.currentTarget;
    // await requestTypeCarnets();
    const data = {
      status: dataset.status,
      created: dataset.created,
      expired: dataset.expired,
      name_user: dataset.name,
      last_name_user: dataset.lastname,
      number_id_user: dataset.dni,
      email_user: dataset.email,
      type_card: dataset.type,
      data_source: dataset.datasource,
      blood_type: dataset.bloodtype,
      card_type_id: dataset.cardtypeid,
      custom_data: dataset.customdata || null,
      special_condition: dataset.specialCondition,
      origin_place: dataset.originPlace,
    };
    setViewData(data);
    setIsOpenModal(true);
    setLoading(false);
  };

  //cierra modal de ver detalles del carnet
  const handleCloseToModal = (event) => {
    event.preventDefault();
    setIsOpenModal(false);
  };
  //Obtener valor por clave especifica del objeto
  const getFieldValue = (fieldName) => {
    return viewData[fieldName];
  };
  // <-------

  //Lógica para crear ---->

  // <-------

  //Lógica para editar ---->

  // <-------

  //Lógica para eliminar ---->

  // <-------

  //Calcula cuantas filas debe mostrarse de la página especifica y ejecuta funcion searchValidation con la pagina y filas determinadas
  const pageIndexAndPageSize = async (pageSize) => {
    await setPaginaSize(pageSize);
    await setEntriesStart(currentPage === 1 ? currentPage : (currentPage - 1) * pageSize + 1);
    //await requestCarnets(currentPage, pageSize);
    // searchValidation(currentPage, pageSize);
  };
  /*
  const requestUserPerId = async (idUser) => {
    try {
      const user = await getUserId(idUser);
      const { id, name, lastname, number_id, email, created_at } = user;
      await setUserId({
        id: id,
        name: name,
        lastname: lastname,
        number_id: number_id,
        email: email,
        created: created_at,
      });
      return { id, name, lastname, number_id, email, created_at };
    } catch (error) {
    }
  };
  */

  // cambio de vigencia de carnets --------->

  const [selected, setSelected] = useState([]);
  const [editedDataValidity, setEditedDataValidity] = useState({});
  const [openValidity, setOpenValidity] = useState(false);
  const [isFormModified, setIsFormModified] = useState(false);

  //Esperar respuesta de la función updatedCardValidity y validar respuesta para actualizar tabla o mostrar error
  const requestUpdateValidityCard = async (editValidityCard) => {
    try {
      const result = await updatedCardValidity(editValidityCard);

      if (result.status !== false) {
        const [numInvalidCards, numCardsNotFound] = result.payload;

        // Llamar a la función reutilizable
        handleValidityAlerts(numInvalidCards, numCardsNotFound, handleAlert);

        callHandleClickSubmit();
      } else {
        handleAlert("fail", result.message || "Error al consultar al servidor");
        setError("Error al consultar al servidor");
      }
    } catch (error) {
      handleAlert("fail", error.message || "Error al consultar al servidor");
      setError("Error al consultar al servidor");
    }
  };

  //Mandar las ids de los carnets para ser descargados
  const requestDownloadCardAccumulated = async (ids) => {
    setLoading(true);
    const result = await downloadCardAccumulated(ids);
    if (result.status !== false) {
      const { blob } = result;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = "Carnets"; // Nombre del archivo a descargar
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);

      setLoading(false);
      handleAlert("success", result.message || "Se descargó correctamente el archivo");
    } else {
      setLoading(false);
      handleAlert("fail", result.message);
    }

    // if (result.status !== false) {
    //   // requestCarnets(currentPage);
    // } else {
    //   setError("Error al consultar al servidor");
    // }
  };

  // Maneja las alertas de exito fallo
  const handleAlert = (typeAlert, message) => {
    setTypeAlert(typeAlert);
    setMessage(message);
    setIsAlert(true);
  };
  //cerrar modal de cambio de vigencia de carnets
  const handleCloseEditValidity = () => setOpenValidity(false);

  //Obtener valor por clave especifica del objeto
  const getFieldValueEditValidity = (fieldName) => {
    return editedDataValidity[fieldName];
  };

  //Cambiar valor por clave y valor especifico del objeto
  const handleFieldChangeEditValidity = (fieldName, value) => {
    setEditedDataValidity({
      ...editedDataValidity,
      [fieldName]: value,
    });
  };

  //ejecuta la funcion requestUpdateValidity con la información necesaria y cierra el modal de actualizar vigencia
  const handleSubmitEditValidity = async (e) => {
    e.preventDefault();
    setLoading(true);
    await requestUpdateValidityCard(editedDataValidity);
    handleCloseEditValidity();
    setLoading(false);
  };

  //ejecuta la funcion requestUpdateValidity con la información necesaria y cierra el modal de actualizar vigencia
  const handleSubmitCardAccumulated = (e) => {
    e.preventDefault();
    const data = {
      idArray: selected,
    };
    requestDownloadCardAccumulated(data);
  };

  //abre el modal para cambiar la fecha de vigencia a un grupo de carnets
  const handleOpenValidity = (event) => {
    event.preventDefault();
    setOpenValidity(true);
    setIsDisabled(false);
    //const { dataset } = event.currentTarget;
    const data = {
      expires_in: "",
      idArray: selected,
    };
    //setDefaultData(data);
    setEditedDataValidity(data);
  };

  // *********Se implementó en el filterController******
  // useEffect(() => {
  //   requestCarnets(currentPage, paginaSize);
  // }, [currentPage]);

  // Comprueba si algún campo ha cambiado desde los valores iniciales(vacio o nulo)
  useEffect(() => {
    const requiredFields = ["expires_in"];
    const someFieldIsEmpty = requiredFields.some((fieldName) => !editedDataValidity[fieldName]);
    setIsFormModified(someFieldIsEmpty);
  }, [editedDataValidity]);

  //Cambio de estado de carnets ------>
  const [openEditedStatus, setOpenEditedStatus] = useState(false);
  const [editStatusCarnet, setEditStatusCarnet] = useState({});
  const [idCarnet, setIdCarnet] = useState("");

  const handleCloseEditedStatus = () => setOpenEditedStatus(false);
  const requestEditStatusCarnet = async (id, statusCarnet) => {
    try {
      const result = await updatedStatusCarnet(id, statusCarnet);
      if (result.status !== false) {
        // const { data, last_page, total, from, to } = result;
        // await setListCarnets(data);

        //requestCarnets(currentPage);
        callHandleClickSubmit();
        handleCloseEditedStatus();
        handleAlert("success", "Estado del carnet actualizado correctamente");
        setError("");
      } else {
        handleAlert("fail", result.message || "Error al consultar al servidor");
        setError("Error al consultar al servidor");
      }
    } catch (error) {
      handleAlert("fail", error.message || "Error al consultar al servidor");
      setError("Error al consultar al servidor");
    }
  };

  const handleEditStatusCarnet = async (event) => {
    event.preventDefault();
    const { dataset } = event.currentTarget;
    const statusEdited = dataset.status !== "Activo" ? "Activo" : "Inactivo";
    const data = {
      status: statusEdited,
    };
    setIdCarnet(dataset.idcarnet);
    setEditStatusCarnet(data);
    setOpenEditedStatus(true);
  };

  const handleSubmitEditedStatusCarnet = async (e) => {
    e.preventDefault();
    setLoading(true);
    await requestEditStatusCarnet(idCarnet, editStatusCarnet);
    setLoading(false);
  };
  //<--------

  const canDownloadFile = usePermission("Card.file.byId");
  const canGetCarnetById = usePermission("Card.byId");
  const canEdit = usePermission("Card.edit");

  const getLocalDate = (dateString) => {
    const date = new Date(dateString);

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
      hour12: true, // Formato de 12 horas
    };

    return date.toLocaleString("es-CO", options); // "es-CO" es el código de lenguaje para Colombia
  };

  //mapeo de las filas que se listaran en la tabla de carnets
  const rows = listCarnets
    ? listCarnets.map((carnet) => {
        return {
          id: carnet.id,
          dni: carnet.number_id,
          email: carnet.email,
          card_type_name: carnet.card_type_name,
          name: `${carnet.card_user_name} ${carnet.card_user_lastname}`,
          created: getLocalDate(carnet.created),
          expired_in: getLocalDate(carnet.expires_in),
          joined:
            Number(carnet.joined) === 1 ? (
              <CheckCircleIcon
                style={{ fontSize: "200px", width: "24px", height: "24px", color: "green" }}
              />
            ) : (
              <CheckCircleIcon
                style={{ fontSize: "200px", width: "24px", height: "24px" }}
                color="disabled"
              />
            ),
          status:
            carnet.status === "Activo" ? (
              <MDBadge badgeContent="Activo" size="xs" container color="success" />
            ) : (
              <MDBadge badgeContent={carnet.status} size="xs" container color="error" />
            ),
          blood_type: carnet.blood_type,
          notified:
            carnet.notified == "1" ? (
              <AccessTimeOutlinedIcon
                style={{ fontSize: "200px", width: "24px", height: "24px" }}
                color="secondary"
                titleAccess="Enviado desde el sistema"
              ></AccessTimeOutlinedIcon>
            ) : (
              <MailOutlinedIcon
                style={{ fontSize: "200px", width: "24px", height: "24px" }}
                color="secondary"
                titleAccess="No notificado"
              ></MailOutlinedIcon>
            ),
          latest_link_status:
            carnet?.latest_link_status == "1" ? (
              <CheckCircleIcon
                style={{ fontSize: "200px", width: "24px", height: "24px", color: "green" }}
                titleAccess="Descargado"
              />
            ) : (
              <CheckCircleIcon
                style={{ fontSize: "200px", width: "24px", height: "24px" }}
                color="disabled"
                titleAccess="No descargado"
              />
            ),
          latest_link_created_at: carnet?.latest_link_created_at
            ? getLocalDate(carnet.latest_link_created_at)
            : "N/A",
          actions: (
            <>
              {canGetCarnetById && (
                <a
                  data-dni={carnet.number_id}
                  data-name={carnet.card_user_name}
                  data-lastname={carnet.card_user_lastname}
                  data-status={carnet.status}
                  data-bloodtype={carnet.blood_type}
                  data-created={carnet.created}
                  data-expired={carnet.expires_in}
                  data-type={carnet.card_type_name}
                  data-email={carnet.email}
                  data-datasource={carnet.data_source_name}
                  data-customdata={carnet.custom_data ? JSON.stringify(carnet.custom_data) : ""}
                  data-special-condition={carnet.special_condition}
                  data-origin-place={carnet.origin_place}
                  data-userid={carnet.card_user_id}
                  data-cardtypeid={carnet.card_type_id}
                  style={{ cursor: "pointer" }}
                  onClick={handleOpenToModal}
                >
                  <FindInPageOutlinedIcon
                    titleAccess="Detalles"
                    style={{
                      fontSize: "200px",
                      width: "24px",
                      height: "24px",
                      backgroundImage: "#000000",
                    }}
                  ></FindInPageOutlinedIcon>
                  {/*<img src={verDetallesImg} />*/}
                </a>
              )}
              {canDownloadFile && (
                <>
                  {carnet.status === "Inactivo" ? (
                    <a
                      style={{
                        cursor: "pointer",
                        pointerEvents: "none",
                        cursor: "not-allowed",
                        textDecoration: "none",
                        color: "inherit",
                        marginLeft: "8px",
                        opacity: "0.5",
                      }}
                    >
                      <DownloadIcon
                        titleAccess="Descargar Carnet"
                        style={{
                          fontSize: "200px",
                          width: "24px",
                          height: "24px",
                          backgroundImage: "#000000",
                        }}
                      />
                    </a>
                  ) : (
                    <a
                      data-id={carnet.id}
                      onClick={handleDownloadCardById}
                      style={{
                        cursor: "pointer",
                        textDecoration: "none",
                        color: "inherit",
                        marginLeft: "8px",
                      }}
                    >
                      <DownloadIcon
                        titleAccess="Descargar Carnet"
                        style={{
                          fontSize: "200px",
                          width: "24px",
                          height: "24px",
                          backgroundImage: "#000000",
                        }}
                      />
                    </a>
                  )}
                </>
              )}
              {canEdit && (
                <>
                  {carnet.status === "Activo" ? (
                    <a
                      data-dni={carnet.number_id}
                      data-name={carnet.card_user_name}
                      data-lastname={carnet.card_user_lastname}
                      data-status={carnet.status}
                      data-created={carnet.created}
                      data-expired={carnet.expires_in}
                      data-type={carnet.card_type_name}
                      data-userid={carnet.card_user_id}
                      data-cardtypeid={carnet.card_type_id}
                      data-idcarnet={carnet.id}
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      onClick={handleEditStatusCarnet}
                    >
                      <CreditCardOffOutlinedIcon
                        style={{
                          fontSize: "200px",
                          width: "24px",
                          height: "24px",
                          backgroundImage: "#000000",
                        }}
                        titleAccess="Desactivar carnet"
                      ></CreditCardOffOutlinedIcon>
                    </a>
                  ) : (
                    <a
                      data-dni={carnet.number_id}
                      data-name={carnet.card_user_name}
                      data-lastname={carnet.card_user_lastname}
                      data-status={carnet.status}
                      data-created={carnet.created}
                      data-expired={carnet.expires_in}
                      data-type={carnet.card_type_name}
                      data-userid={carnet.card_user_id}
                      data-cardtypeid={carnet.card_type_id}
                      data-idcarnet={carnet.id}
                      style={{ cursor: "pointer", marginLeft: "8px" }}
                      onClick={handleEditStatusCarnet}
                    >
                      <CreditCardOutlinedIcon
                        style={{
                          fontSize: "200px",
                          width: "24px",
                          height: "24px",
                          backgroundImage: "#000000",
                        }}
                        titleAccess="Activar carnet"
                      ></CreditCardOutlinedIcon>
                    </a>
                  )}
                </>
              )}
            </>
          ),
        };
      })
    : [];

  //Guarda o borra la id de la fila seleccionada o desceleccionada en el array selected
  const handleSelect = (id) => {
    const newSelected = [...selected];
    const selectedIndex = selected.indexOf(id);

    if (selectedIndex === -1) {
      newSelected.push(id);
    } else {
      newSelected.splice(selectedIndex, 1);
    }
    setSelected(newSelected);
  };

  //Selecciona todas las filas de una pagina y las guarda o borra(si es desceleccionada) en el array selected
  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((row) => row.id);
      setSelected(newSelected);
    } else {
      setSelected([]);
    }
  };

  //<---------

  // Función para llamar a handleClickSubmit desde el componente padre
  const callHandleClickSubmit = () => {
    if (filterControllerRef.current) {
      filterControllerRef.current.handleClickSubmit();
    }
  };

  return (
    <>
      <Spinner loading={loading}></Spinner>
      <MDAlert
        isAlert={isAlert}
        setIsAlert={setIsAlert}
        typeAlert={typeAlert}
        message={message}
      ></MDAlert>
      {usePermission("Card.byFilter") && (
        <FilterController
          data={listCarnets}
          dataFilter={dataFilter}
          dataTable={dataTable}
          setListData={setListCarnets}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          setTotalPages={setTotalPages}
          requestData={requestCarnets}
          setError={setError}
          setTotalData={setTotalData}
          setEntriesEnd={setEntriesEnd}
          setEntriesStart={setEntriesStart}
          setLoading={setLoading}
          ref={filterControllerRef}
        ></FilterController>
      )}
      <ListCarnets
        listCarnets={listCarnets}
        limitResult={limitResult}
        error={error}
        pageIndexAndPageSize={pageIndexAndPageSize}
        entriesStart={entriesStart}
        entriesEnd={entriesEnd}
        totalData={totalData}
        paginaSize={paginaSize}
        currentPage={currentPage}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
        handleOpenToModal={handleOpenToModal}
        selected={selected}
        handleSelect={handleSelect}
        handleSelectAll={handleSelectAll}
        handleOpenValidity={handleOpenValidity}
        handleSubmitCardAccumulated={handleSubmitCardAccumulated}
        rows={rows}
      ></ListCarnets>
      <ViewUserPerCard
        isOpenModal={isOpenModal}
        handleCloseToModal={handleCloseToModal}
        isDisabled={isDisabled}
        typeCarnets={typeCarnets}
        getFieldValue={getFieldValue}
      ></ViewUserPerCard>
      <ValidityCarnet
        open={openValidity}
        handleClose={handleCloseEditValidity}
        isFormModified={isFormModified}
        isDisabled={isDisabled}
        getFieldValue={getFieldValueEditValidity}
        handleFieldChange={handleFieldChangeEditValidity}
        handleSubmit={handleSubmitEditValidity}
        selected={selected}
      ></ValidityCarnet>
      <CarnetEditedStatus
        openEditedStatus={openEditedStatus}
        handleCloseEditedStatus={handleCloseEditedStatus}
        infoStatus={editStatusCarnet}
        handleSubmitDelete={handleSubmitEditedStatusCarnet}
      ></CarnetEditedStatus>
    </>
  );
}
